var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.members.length === 0)?_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('Spinner')],1):_c('div',[_c('table',{ref:"dt",attrs:{"id":"table"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }